import React from "react";
import { useTranslation } from "react-i18next";
import { TRANSLATION_CONFIG } from "../../../../utils/consts/translation";
import { TimerSection } from "../Timer";
import { Button } from "../../../atom/Button";
import { QuestionItem } from "./QuestionItem";
import { SummaryStateType } from "../../../../types/components";
import { ParticipantExamQuestion } from "../../../../types/question";

interface SidebarProps {
  questions: ParticipantExamQuestion[];
  currentQuestion: number;
  answers: Record<number, string>;
  flags: Record<number, boolean>;
  onSelectQuestion: (index: number) => void;
  toggleFlag: (questionNumber?: number) => void;
  setIsSummary: React.Dispatch<React.SetStateAction<SummaryStateType>>;
  setIsCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  isPractice?: boolean;
}

export const Sidebar = ({
  questions,
  currentQuestion,
  flags,
  onSelectQuestion,
  toggleFlag,
  setIsSummary,
  setIsCompleted,
  isPractice,
}: SidebarProps) => {
  const { t } = useTranslation(TRANSLATION_CONFIG.appNamespace);

  return (
    <div className="flex flex-col max-h-screen max-w-[492px] min-w-[492px] border-r border-gray-200">
      <div className="flex items-center justify-between border-b border-gray-200 w-full p-5 pl-7 h-[76px]">
        <img src="/images/logo.svg" className="h-[24px]" alt="" />
        {!isPractice && <TimerSection setIsTimerCompleted={setIsCompleted} />}
      </div>
      <div className="flex-1 overflow-y-auto custom-scrollbar">
        <div className="p-5 pl-7">
          <p className="text-gray-400 font-outfit text-[13px] font-medium leading-[13px] tracking-[2px] uppercase">
            {t("Questions")}:
          </p>
        </div>
        <ul className="space-y-[1px]">
          {questions.map((question, index) => {
            return (
              <QuestionItem
                key={index}
                index={index}
                question={question}
                questions={questions}
                flags={flags}
                currentQuestion={currentQuestion}
                onSelectQuestion={onSelectQuestion}
                toggleFlag={toggleFlag}
              />
            );
          })}
        </ul>
      </div>
      <div className="flex justify-center px-7 pt-7 pb-8 border-t border-gray-200 h-[104px]">
        <Button
          type="secondary"
          label={t("Review progress")}
          onClick={() => setIsSummary({ filter: "all", state: true })}
        />
      </div>
    </div>
  );
};
